import React, { Component } from "react";
import * as s from "./DocumentCard.module.scss";
import { ISingleWordpressDocument } from "resource-centre-theme/src/models";
import { truncate } from "resource-centre-theme/src/libs/utils";
import {
  BackgroundImage,
  P,
  Overlay,
  DynamicLink,
} from "resource-centre-theme/src/views/shared/components";
import { Icons } from "resource-centre-theme/src/libs/assets";
import { inject, observer } from "mobx-react";
import {
  SectionsContainerStore,
  NavigationStore,
  AuthenticationStore,
  LibraryStore,
} from "resource-centre-theme/src/stores";
import {
  CopyLink,
  DocumentInformation,
} from "resource-centre-theme/src/views/shared/modals";
import { fallbackImage } from "resource-centre-theme/src/libs/utils/fallbacks";

interface Props {
  document: ISingleWordpressDocument;
  sectionsContainerStore?: SectionsContainerStore;
  navigationStore?: NavigationStore;
  authenticationStore?: AuthenticationStore;
  libraryStore?: LibraryStore;
}

interface State {
  copyLinkOverlayOpen: boolean;
  informationOverlayOpen: boolean;
}

@inject(
  "sectionsContainerStore",
  "navigationStore",
  "authenticationStore",
  "libraryStore"
)
@observer
export class DocumentCard extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      copyLinkOverlayOpen: false,
      informationOverlayOpen: false,
    };
  }

  toggleLinkOverlay = (e) => {
    e.preventDefault();
    const { sectionsContainerStore } = this.props;
    const { copyLinkOverlayOpen } = this.state;
    this.setState({ copyLinkOverlayOpen: !copyLinkOverlayOpen });

    if (!copyLinkOverlayOpen) {
      sectionsContainerStore.setScrollPos();
    } else {
      sectionsContainerStore.resetScrollPos();
    }
  };

  toggleInformationOverlay = (e) => {
    e.preventDefault();
    const { sectionsContainerStore } = this.props;
    const { informationOverlayOpen } = this.state;
    this.setState({ informationOverlayOpen: !informationOverlayOpen });

    if (!informationOverlayOpen) {
      sectionsContainerStore.setScrollPos();
    } else {
      sectionsContainerStore.resetScrollPos();
    }
  };

  render() {
    const {
      document,
      navigationStore,
      authenticationStore,
      libraryStore,
    } = this.props;
    const { userHasValidToken } = authenticationStore;
    const { location } = navigationStore;
    const { origin } = location;
    const { copyLinkOverlayOpen, informationOverlayOpen } = this.state;
    const {
      documentThumbnail,
      title,
      link,
      documentFields,
      documentPublishers,
      documentContentTypes,
    } = document || {};
    const { format } = documentFields || {};
    const isVideo = format === "MP4";
    const { publishers } = documentPublishers || {};
    const { contentTypes } = documentContentTypes || {};
    const { image } = documentThumbnail || {};
    const { publicationYear, documents } = documentFields || {};

    const classes = [s.documentCard];

    return (
      <div className={classes.join(" ")}>
        {copyLinkOverlayOpen && (
          <Overlay>
            <CopyLink
              toggleOverlay={this.toggleLinkOverlay}
              link={origin + link}
            />
          </Overlay>
        )}
        {informationOverlayOpen && (
          <Overlay>
            <DocumentInformation
              toggleOverlay={this.toggleInformationOverlay}
              document={document}
            />
          </Overlay>
        )}
        <div className={s.image}>
          <div className={s.corner}></div>
          <DynamicLink to={link}>
            <div className={s.overlay}>
              <div className={s.overlayTopRow}>
                <img
                  src={Icons.more_small_white}
                  className={s.moreButton}
                  onClick={this.toggleInformationOverlay}
                />
                <img
                  src={Icons.link_small_white}
                  className={s.linkButton}
                  onClick={this.toggleLinkOverlay}
                />
              </div>
              <div className={s.overlayBottomRow}>
                {contentTypes?.length > 0 && (
                  <P small className={s.overlayContentType}>
                    {truncate(contentTypes[0]?.name, 30)}
                  </P>
                )}
                {userHasValidToken && (
                  <div className={s.libraryButton}>
                    <img
                      src={Icons.library_small_white}
                      className={s.libraryIcon}
                      onClick={() => libraryStore.onOpenModal(document)}
                    />
                  </div>
                )}
              </div>
            </div>
            {isVideo && (
              <img src={Icons.play_button} className={s.playButton} />
            )}
            <BackgroundImage
              image={image || fallbackImage(documents?.[0].documentLinkType)}
            />
          </DynamicLink>
        </div>
        <DynamicLink to={link}>
          {title && (
            <P medium className={s.title}>
              {truncate(title, 75)}
            </P>
          )}
          <div className={s.publishingContainer}>
            <P className={s.publishingInformationLabel}>
              {publicationYear}
              {publishers?.length > 0 && publishers[0] && " · "}
              {publishers?.length > 0 && publishers[0]?.name}
            </P>
          </div>
        </DynamicLink>
      </div>
    );
  }
}
